export default __webpack_public_path__ + "static/media/default-deal-car.7477d4dc.png";